import { FC } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { TabBar } from '@revolut-internal/ui-kit'

import { TabBarLink } from 'components/TabBarLink/TabBarLink'
import { getChatDebugAssistantRoute, getChatDebugSupportRoute } from 'lib/router'
import { useUser } from 'containers/App'

export const ChatDebugTabs: FC = () => {
  const { hasPermission } = useUser()

  const canSeeAssistantTab = hasPermission('debug.dialogue_snapshot.view.all')

  const { pathname } = useLocation()
  const isSupportTab = matchPath(
    { path: getChatDebugSupportRoute(), end: false },
    pathname,
  )

  if (!canSeeAssistantTab) {
    return null
  }

  return (
    <TabBar>
      <TabBarLink
        aria-label="Support"
        aria-selected={!!isSupportTab}
        to={getChatDebugSupportRoute()}
      >
        Support
      </TabBarLink>
      <TabBarLink
        aria-label="Assistant"
        aria-selected={!isSupportTab}
        to={getChatDebugAssistantRoute()}
      >
        Assistant
      </TabBarLink>
    </TabBar>
  )
}
